define('root/Assets/Templates/Content/PartnerSlider/Js/PartnerSlider',[
	'jquery',
	'flickity',
	'base/MbiHelper'


], function(
	$,
	Flickity,
	_
)
{
	'use strict';
	// ----------------------------------------------------------------
	// SWIPER 2 SETUP
	// ----------------------------------------------------------------
    function initSlider(e, o){
        var elem = document.querySelector(e);
        var options = {};
        if (o != undefined) {
            options = o;
        } else {
            options = {
                cellAlign: 'center',
                contain: true,
                cellSelector: '.js_swiper__slide',
                // accessibility: false,
                // percentPosition: false,
                // freeScroll: true,
                prevNextButtons: false,
                // setGallerySize: true
                adaptiveHeight: false,
                pageDots: false,
                wrapAround: true,
            }
        }

        setTimeout(function() {
            var flkty = new Flickity( elem, options);

            var $prevB = $(elem).parent().find('.button-prev');
            var $nextB = $(elem).parent().find('.button-next');
            var buttons = [$prevB, $nextB];

                var event = 'click'
                $.each( buttons,function(index, el) {
                    $(el).unbind(event);
                    $(el).on(event, function(evt) {
                        evt.stopPropagation();
                        evt.preventDefault();
                        // console.log(event);
                        if ($(this).hasClass('button-next')) {
                            flkty.next(true, false);
                        } else {
                            flkty.previous(true, false);
                        }
                    });
                });
            // }

        // return flkty;
        }, 10);
    }

	initSlider('.js_swiper-partner');





});
